import { Context, createContext, MutableRefObject } from "react";
import { BlocAppWrapper } from "../ui/bloc/BlocAppWrapper";
import IBloc from "./IBloc";

export interface AppShare {
    apiHandler: ApiHandler;
    app: BlocAppWrapper;
    showAlert: { (title: string, message: string, label: string, onCallBack?: { (data: any): void } | null, dismiss?: boolean | true): any };
    // showInfo:{(title:string,message:string,label:string,onCallBack?:{(data: any):void}|null,dismiss?:boolean|true)};
    showConFirm: { (title: string, message: string, labelLeft?: string | '', labelRight?: string | '', onCallBack?: { (data: any): void } | null, dismiss?: boolean | false, type?: any): any };
    toastBR: MutableRefObject<any>;
    showToast: { (severity: any | null | '', summary: any | null | '', message: any | null | ''): any };
    portScan: 8080;
    currentBloc: any
    dateTimeFormat?: { dateFormat: string, dateTimeFormat: string, timeFormat: string, calendarViewDate: string, calendarViewDateTime: string, timeDateFormat?: string } |
    { dateFormat: 'DD-MM-YYYY', dateTimeFormat: 'YYYY-MM-DD HH:mm:ss', timeFormat: "HH:mm:ss", calendarViewDate: 'yy/mm/dd', calendarViewDateTime: 'yy/mm/dd HH:mm', timeDateFormat: 'HH:mm:ss YYYY-MM-DD' }

}
export interface ApiHandler {
    showLoading: { (isShow: boolean): void };
    onUnAuth: { (): void };
    onError: { (error: any): void }
}

export const AppContext: Context<AppShare | null> = createContext<AppShare | null>(null);

export function reUseBloc<T extends IBloc>(appContext: AppShare, blocType: { new(appContext: AppShare): T; }): T {
  
    if (appContext.app.blocChild) {
        if (appContext.app.blocChild.constructor.name === blocType.name) {
         
            return appContext.app.blocChild;
        } else {
            try {
             
                appContext.app.blocChild.dispose();
                appContext.app.blocChild = null;
            } catch (e) { }

         
            appContext.app.blocChild = new blocType(appContext);
            return appContext.app.blocChild;
        }
    }
 
    appContext.app.blocChild = new blocType(appContext);
    return appContext.app.blocChild;
}


export function propsToBloc<T extends IBloc>(props: any, blocType: { new(): T; }): T | null {

    if (props.bloc) {
        if (props.bloc.constructor.name === blocType.name) {
         
            return props.bloc
        }
    }
    
    return null
}

